'use strict';

var transferReasonCodes = {
    JOB_DELETED: 'job.deleted',
    JOB_PAUSED: 'job.paused',
    JOB_STOPPED: 'job.stopped',
    TRANSFER_START_FAILED: 'transfer.startFailed',
    TRANSFER_FAILED: 'transfer.failed'
};

module.exports = transferReasonCodes;